import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { equipmentService } from "../../Services/equipment.service";
import Spinner from "../Components/Spinner";

const ModalSearchEquipment = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [data, setData] = useState([]);

  const handleClose = () => props.handleClose(!props.show);

  const handleSelect = async (item) => {
    setTimeout(() => {
      props.handleSelect(item);
    }, 500);
  };

  useEffect(() => {
    (async () => {
      if (props.show) {
        if (props.filter.lineNumber) {
          setFilterName(
            <>
              <span style={{ paddingRight: "5px" }}>
                Filtrando por Número da linha{" "}
              </span>
              <span className='badge bg-label-primary'>
                {" "}
                {props.filter.lineNumber}
              </span>
            </>
          );

          setIsLoading(true);
          try {
            const equipment = await equipmentService.searchByLineNumber(
              props.filter.lineNumber
            );
            setData(equipment);
          } catch (error) {
          } finally {
            setIsLoading(false);
          }
          return;
        }

        if (props.filter.serial) {
          setFilterName(
            <>
              <span style={{ paddingRight: "5px" }}>Filtrando por Serial </span>
              <span className='badge bg-label-primary'>
                {" "}
                {props.filter.serial}
              </span>
            </>
          );

          setIsLoading(true);
          try {
            const equipments = await equipmentService.searchBySerial(
              props.filter.serial
            );
            setData(equipments);
          } catch (error) {
          } finally {
            setIsLoading(false);
          }
        }
      }
    })();
  }, [props]);

  return (
    <>
      <Modal
        id='modalChips'
        show={props.show}
        backdrop='static'
        size='lg'
        fullscreen='true'
        onHide={handleClose}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar Equipamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <>
              <h5>Buscando...</h5>
              <Spinner />
            </>
          ) : (
            <>
              {data && data?.length > 0 ? (
                <>
                  <div className='card'>
                    <h5 className='card-header'>{filterName}</h5>
                    <div className='card-body'>
                      <table className='table table-bordered'>
                        <thead>
                          <tr>
                            <th>Serial</th>
                            <th>Número Linha</th>
                            <th>ICCID</th>
                            <th>Modelo</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data &&
                            data.map((item, index) => (
                              <tr
                                key={index}
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSelect(item)}>
                                <td>{item.serial}</td>
                                <td>{item.lineNumber}</td>
                                <td>{item.iccId}</td>
                                <td>{item.modelEquipmentName}</td>
                                <td>{item.statusEquipmentName}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h5>
                    😅Sem registros encontrados para este filtro. Mude seu
                    filtro e tente novamente!
                  </h5>
                </>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalSearchEquipment;
